<ng-container [ngSwitch]="historyColumn.type">
  <span *ngSwitchCase="'TEXT'" class="cell">{{cellData}}</span>
  <span *ngSwitchCase="'DATE'" class="cell date-field">{{cellData|date:'dd MMM y'}}</span>
</ng-container>
